import { render, staticRenderFns } from "./updatePassword.vue?vue&type=template&id=5be0870e"
import script from "./updatePassword.vue?vue&type=script&lang=js"
export * from "./updatePassword.vue?vue&type=script&lang=js"
import style0 from "./updatePassword.vue?vue&type=style&index=0&id=5be0870e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports